import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import Form from '@rjsf/core';
import { customizeValidator } from '@rjsf/validator-ajv8';
import PropTypes from 'prop-types';

import apiRequest from '@/apiRequest';
import classes from '@/components/ExtraActions/ChecklistForm/style.module.scss';
import { customFormats } from '@/helpers/isValidDateTimeFormat';
import { Services } from '@/orderForm/fields';
import uiSchema from '@/orderForm/uiSchema/uiSchemaExtraAction.json';
import TypeGuiada from '@/svg-icons/type-guiada';

const validator = customizeValidator({ customFormats });
const fields = { servicesField: Services };

const ChecklistForm = ({ clientPanel, changePage, orderId }) => {
  const intl = useIntl();

  const [schema] = useState(() => ({
    type: 'object',
    properties: {
      inspector: {
        title: intl.formatMessage({ id: 'RESPONSIBLE_FOR_INSPECTION' }),
        type: 'object',
        required: ['name', 'email'],
        properties: {
          name: {
            title: intl.formatMessage({ id: 'NAME' }),
            type: 'string',
          },
          email: {
            title: intl.formatMessage({ id: 'EMAIL' }),
            type: 'string',
          },
        },
      },
      services: {
        title: intl.formatMessage({ id: 'SERVICES' }),
        items: {
          type: 'object',
          additionalProperties: false,
          properties: {
            type: {
              title: intl.formatMessage({ id: 'TYPE_OF_SERVICE' }),
              type: 'string',
            },
            responsibleEmail: {
              title: intl.formatMessage({ id: 'RESPONSIBLE_EMAIL' }),
              type: 'string',
            },
          },
        },
        type: 'array',
      },
    },
  }));

  const onSubmit = React.useCallback(async ({ formData }) => {
    const payload = {
      type: 'PWA',
      inspector_name: formData.inspector.name,
      inspector_mail: formData.inspector.email,
      available_services: formData.services.filter(
        (service) => service.type !== '' && service.responsibleEmail !== '',
      ),
    };
    try {
      await apiRequest.post(`pwa/${orderId}`, payload);
      changePage(null, 'order-details');
    } catch (err) {
      console.log(err);
    }
  }, [orderId, changePage]);

  return (
    <div className={classes.form} style={clientPanel ? { marginTop: '-15px' } : {}}>
      <h1>
        <TypeGuiada />
        {intl.formatMessage({ id: 'GUIDED_INSPECTION' })}
      </h1>
      <Form
        schema={schema}
        uiSchema={uiSchema}
        fields={fields}
        validator={validator}
        onSubmit={onSubmit}
      >
        <div className={`${classes.field} ${classes.isRightAligned}`}>
          <button type="submit">{intl.formatMessage({ id: 'REQUEST' })}</button>
        </div>
      </Form>
    </div>
  );
};

ChecklistForm.propTypes = {
  clientPanel: PropTypes.bool.isRequired,
  changePage: PropTypes.func.isRequired,
  orderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ChecklistForm;
